import React, { PureComponent } from 'react';
import * as _ from 'underscore';

import { SelectableGroup } from 'react-selectable';
import CalendarMonth from '../components/CalendarMonth';
import CalendarActionsBar from '../components/CalendarActionsBar';
import CalendarDrawer from '../calendar-library-drawer/CalendarLibraryDrawer';
import CalendarHotKeys from '../components/CalendarHotKeys';
import CalendarSummaryDrawer from '../calendar-summary-drawer/CalendarSummaryDrawer';
import CalendarMessagingDrawer from '../../../v5/messaging/components/CalendarMessagingSummaryDrawer';

import CalendarNavBar from '../../nav/CalendarNavBar';
import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import * as NavState from '../../../state/reducer/nav/nav';

import Console from '../../../lib/debug';

export default class CalendarBase extends PureComponent {
    componentWillMount() {
        NavState.enableCalendarHeader();
    }

    componentWillUnmount() {
        NavState.disableCalendarHeader();
    }

    handleSelection(selectedSessionKeys) {
        let sessionIds = _.map(selectedSessionKeys, key =>
            parseInt(key.split('_')[0])
        );
        ClipboardState.select(sessionIds);
    }
    render() {
        Console.render('CalendarBase');
        return (
            <div>
                <CalendarNavBar />
                <SelectableGroup
                    selectOnMouseMove
                    onSelection={this.handleSelection}
                >
                    <CalendarMonth />
                </SelectableGroup>
                <CalendarDrawer />
                <CalendarSummaryDrawer />
                <CalendarMessagingDrawer
                    callback={this.props.messagingCallback}
                />
                <CalendarActionsBar />
                <CalendarHotKeys />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/calendar/calendar-base/CalendarBase.jsx